import locale_nl from 'dayjs/locale/nl'
import locale_en from 'dayjs/locale/en'

export const dayJs = (date: string) => {
  const locale = baseI18nGetActiveCode() === 'nl' ? locale_nl : locale_en
  return baseDayJs(date).locale(locale)
}
